export default function AuthPage(){
    return(
        <>
        <h1>Страница авторизации</h1>
        </>
    )
}